import React from 'react'
import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const LockedFeatureOverlay = ({ children, locked, onLockClick, title }) => {
  const { t } = useTranslation()

  if (!locked) return children

  return (
    <div className="relative group cursor-pointer" onClick={onLockClick}>
      {/* Blurred Content */}
      <div className="filter blur-[6px] pointer-events-none select-none opacity-50 transition-all duration-500 group-hover:blur-[8px]">
        {children}
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-black/20 rounded-xl transition-colors group-hover:bg-black/30">
        <div className="bg-[#1c1c1e] p-4 rounded-full shadow-[0_0_20px_rgba(249,115,22,0.3)] border border-orange-500/30 mb-3 group-hover:scale-110 transition-transform duration-300">
          <Lock className="w-8 h-8 text-orange-500" />
        </div>
        
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-black text-[10px] font-black px-2 py-0.5 rounded uppercase tracking-wider mb-2">
          {t('premium_modal.locked_label')}
        </div>
        
        {title && (
          <h3 className="text-white font-bold text-sm text-center px-4 drop-shadow-md">
            {title}
          </h3>
        )}
      </div>
    </div>
  )
}

export default LockedFeatureOverlay
